<h4 class="secondary-text" style="text-align: left; margin: 0 0 12px -10px">
    <button mat-icon-button
            color="primary"
            title="Back to sign in page"
            (click)="onBackToCredentialsLogIn()"
    >
        <mat-icon aria-hidden="true">arrow_back</mat-icon>
    </button>
    Back to sign in page
</h4>

<div class="title" style="text-align: left">
    Set Up Multi-Factor Authentication
</div>

<p class="mfa-login-setup-info">Please enter which phone number you would like to receive your verification code.</p>

<mat-form-field class="mfa-phone">
    <mat-label>Phone number</mat-label>
    <input matInput type="tel" [formControl]="phoneNumberCtrl" ngcAutofocus>
    <mat-error *ngIf="phoneNumberCtrl?.errors?.phoneNumberIsInvalid" class="mt-4">Phone number is invalid
    </mat-error>
</mat-form-field>

<div class="form-field-info mat-caption secondary-text mfa-login-setup-info info-field">*By entering your number, you agree to receive text messages at the phone number provided.</div>
<div class="form-field-info mat-caption secondary-text mfa-login-setup-info info-field">Please, don`t forget to use your country code.</div>

<div class="dialog-actions mt-32">
    <button mat-raised-button
            type="button"
            color="primary"
            [disabled]="phoneNumberCtrl?.value && phoneNumberCtrl?.invalid"
            (click)="onSave()"
            class="submit-button"
    >
        Send code
    </button>
</div>
